"use client"

import { useAppStore } from "@/stores/app-store"

let wired = false

/** Cold-start default product when the tenant has not chosen one in Settings. */
export function ensureSurveyAppStartupDefaults(): void {
  if (wired || typeof window === "undefined") return
  wired = true

  const apply = () => {
    const { startupProduct, setStartupProduct } = useAppStore.getState()
    if (!startupProduct) {
      setStartupProduct({ product: "exxat-surveys" })
    }
  }

  if (useAppStore.persist.hasHydrated()) {
    apply()
  } else {
    useAppStore.persist.onFinishHydration(apply)
  }
}
